/**
 * Arte da explosão de cada bomba: o `BombPartical` de `BallList.xml` do legado (`BallInfo.blastOutID`). A animação `blastOutMovie<id>` fica no atlas
 * `bomb/bullet/bullet<id>`. Só as bombas em que o id da explosão é diferente do id da bomba estão aqui; nas demais os dois ids são iguais.
 * É só arte: o raio e o dano da explosão vêm do servidor.
 */
const BLAST_OUT: Readonly<Record<number, number>> = {
  0: 1,
  19: 18,
  21: 20,
  26: 20,
  27: 20,
  28: 20,
  29: 20,
  30: 22,
  31: 23,
  32: 6,
  33: 9,
  34: 51,
  35: 68,
  36: 661,
  37: 481,
  38: 661,
  42: 18,
  43: 18,
  46: 45,
  47: 45,
  48: 45,
  49: 45,
  58: 54,
  59: 64,
  102: 101,
  103: 101,
  104: 101,
  112: 111,
  113: 111,
  114: 111,
  122: 121,
  123: 121,
  124: 121,
  132: 131,
  133: 131,
  134: 131,
  142: 141,
  143: 141,
  144: 141,
  152: 151,
  153: 151,
  154: 151,
  162: 161,
  163: 161,
  164: 161,
  172: 171,
  173: 171,
  174: 171,
  222: 221,
  223: 221,
  232: 231,
  233: 231,
  242: 241,
  243: 241,
  252: 251,
  253: 251,
  262: 261,
  263: 261,
  272: 271,
  273: 271,
  281: 282,
  283: 282,
  284: 282,
  292: 291,
  293: 291,
  294: 291,
  322: 321,
  323: 321,
  324: 321,
  332: 331,
  333: 331,
  334: 331,
  342: 341,
  343: 341,
  344: 341,
  352: 351,
  353: 351,
  354: 351,
  362: 361,
  363: 361,
  364: 361,
  372: 371,
  373: 371,
  374: 371,
  382: 381,
  383: 381,
  384: 381,
  392: 391,
  393: 391,
  394: 391,
  402: 401,
  403: 401,
  404: 401,
  412: 411,
  413: 411,
  414: 411,
  462: 461,
  463: 461,
  464: 461,
  472: 471,
  473: 471,
  474: 471,
  482: 481,
  483: 481,
  484: 481,
  492: 491,
  493: 491,
  494: 491,
  662: 661,
  663: 661,
  664: 661,
  672: 671,
  673: 671,
  674: 671,
  702: 701,
  703: 701,
  704: 701,
  712: 711,
  713: 711,
  714: 711,
  881: 331,
  882: 331,
  883: 331,
  884: 331,
  891: 131,
  901: 411,
  902: 411,
  903: 411,
  904: 411,
  911: 171,
  912: 171,
  913: 171,
  914: 171,
  921: 371,
  922: 371,
  923: 371,
  924: 371,
  931: 671,
  932: 671,
  933: 671,
  934: 671,
  941: 491,
  942: 491,
  943: 491,
  944: 491,
  951: 391,
  952: 391,
  953: 391,
  954: 391,
  971: 711,
  972: 711,
  973: 711,
  974: 711,
  1011: 101,
  1012: 101,
  1021: 101,
  1022: 101,
  1031: 101,
  1032: 101,
  1041: 101,
  1042: 101,
  1211: 121,
  1212: 121,
  1221: 121,
  1222: 121,
  1231: 121,
  1232: 121,
  1241: 121,
  1242: 121,
  1411: 141,
  1412: 141,
  1421: 141,
  1422: 141,
  1431: 141,
  1432: 141,
  1441: 141,
  1442: 141,
  1611: 161,
  1612: 161,
  1621: 161,
  1622: 161,
  1631: 161,
  1632: 161,
  1641: 161,
  1642: 161,
  2211: 221,
  2212: 221,
  2221: 221,
  2222: 221,
  2231: 221,
  2232: 221,
  2411: 241,
  2412: 241,
  2421: 241,
  2422: 241,
  2431: 241,
  2432: 241,
  2611: 261,
  2612: 261,
  2621: 261,
  2622: 261,
  2631: 261,
  2632: 261,
  2811: 281,
  2812: 282,
  2821: 281,
  2822: 282,
  2831: 281,
  2832: 282,
  2841: 281,
  2842: 282,
  3211: 321,
  3212: 321,
  3221: 321,
  3222: 321,
  3231: 321,
  3232: 321,
  3241: 321,
  3242: 321,
  3411: 341,
  3412: 341,
  3421: 341,
  3422: 341,
  3431: 341,
  3432: 341,
  3441: 341,
  3442: 341,
  3611: 361,
  3612: 361,
  3621: 361,
  3622: 361,
  3631: 361,
  3632: 361,
  3641: 361,
  3642: 361,
  3811: 381,
  3812: 381,
  3821: 381,
  3822: 381,
  3831: 381,
  3832: 381,
  3841: 381,
  3842: 381,
  4011: 401,
  4012: 401,
  4021: 401,
  4022: 401,
  4031: 401,
  4032: 401,
  4041: 401,
  4042: 401,
  4611: 461,
  4612: 461,
  4621: 461,
  4622: 461,
  4631: 461,
  4632: 461,
  4641: 461,
  4642: 461,
  4811: 481,
  4812: 481,
  4821: 481,
  4822: 481,
  4831: 481,
  4832: 481,
  4841: 481,
  4842: 481,
  6611: 661,
  6612: 661,
  6621: 661,
  6622: 661,
  6631: 661,
  6632: 661,
  6641: 661,
  6642: 661,
  7011: 701,
  7012: 701,
  7021: 701,
  7022: 701,
  7031: 701,
  7032: 701,
  7041: 701,
  7042: 701,
};

/** Id da arte de explosão da bomba (o da própria bomba, se não há troca). */
export function blastOutId(ballId: number): number {
  return BLAST_OUT[ballId] ?? ballId;
}

/**
 * Giro do projétil no legado (`BallInfo.SpinV` e `SpinVA` do `BallList.xml`): a cada passo de 40 ms o clipe gira `spinV` graus e `spinV` vira
 * `int(spinV * SpinVA)` enquanto `|spinV| > 1`. Bomba que não está aqui não gira; ela só vira de ponta-cabeça quando vai para a esquerda.
 */
const SPIN: Readonly<Record<number, readonly [number, number]>> = {
  9: [90, 0.96],
  33: [90, 0.96],
  35: [90, 0.96],
  36: [60, 1],
  38: [60, 1],
  46: [60, 1],
  47: [90, 1],
  68: [90, 0.96],
  73: [90, 0.96],
  76: [60, 1],
  77: [90, 1],
  83: [90, 0],
  85: [180, 0],
  101: [90, 0.96],
  102: [90, 0.96],
  103: [90, 0.96],
  104: [90, 0.96],
  121: [180, 1],
  122: [180, 1],
  123: [180, 1],
  124: [180, 1],
  131: [180, 1],
  132: [180, 1],
  133: [180, 1],
  134: [180, 1],
  381: [90, 0.96],
  382: [90, 0.96],
  383: [90, 0.96],
  384: [90, 0.96],
  401: [90, 0.96],
  402: [90, 0.96],
  403: [90, 0.96],
  404: [90, 0.96],
  411: [90, 0.96],
  412: [90, 0.96],
  413: [90, 0.96],
  414: [90, 0.96],
  461: [60, 1],
  462: [60, 1],
  463: [60, 1],
  464: [60, 1],
  471: [90, 1],
  472: [90, 1],
  473: [90, 1],
  474: [90, 1],
  661: [60, 1],
  662: [60, 1],
  663: [60, 1],
  664: [60, 1],
  701: [90, 0.96],
  702: [90, 0.96],
  703: [90, 0.96],
  704: [90, 0.96],
  711: [90, 0.96],
  712: [90, 0.96],
  713: [90, 0.96],
  714: [90, 0.96],
  891: [180, 1],
  901: [90, 0.96],
  902: [90, 0.96],
  903: [90, 0.96],
  904: [90, 0.96],
  1011: [90, 0.96],
  1021: [90, 0.96],
  1031: [90, 0.96],
  1041: [90, 0.96],
  1212: [60, 1],
  1222: [60, 1],
  1232: [60, 1],
  1242: [60, 1],
  2811: [90, 0.96],
  2821: [90, 0.96],
  2831: [90, 0.96],
  2841: [90, 0.96],
  3811: [90, 0.96],
  3812: [90, 0.96],
  3821: [90, 0.96],
  3822: [90, 0.96],
  3831: [90, 0.96],
  3832: [90, 0.96],
  3841: [90, 0.96],
  3842: [90, 0.96],
  4011: [90, 0.96],
  4012: [90, 0.96],
  4021: [90, 0.96],
  4022: [90, 0.96],
  4031: [90, 0.96],
  4032: [90, 0.96],
  4041: [90, 0.96],
  4042: [90, 0.96],
  4611: [60, 1],
  4612: [45, 1],
  4621: [60, 1],
  4622: [45, 1],
  4631: [60, 1],
  4632: [45, 1],
  4641: [60, 1],
  4642: [45, 1],
  6611: [60, 1],
  6612: [60, 1],
  6621: [60, 1],
  6622: [60, 1],
  6631: [60, 1],
  6632: [60, 1],
  6641: [60, 1],
  6642: [60, 1],
  7011: [90, 0.96],
  7012: [90, 0.96],
  7021: [90, 0.96],
  7022: [90, 0.96],
  7031: [90, 0.96],
  7032: [90, 0.96],
  7041: [90, 0.96],
  7042: [90, 0.96],
};

export function ballSpin(ballId: number): readonly [spinV: number, spinVA: number] | null {
  return SPIN[ballId] ?? null;
}

/** Giro acumulado (graus) depois de `steps` passos de 40 ms, para o lado `dir` (1 = direita, -1 = esquerda). Igual a `SimpleBomb.updatePosition`. */
export function spinDegrees(spinV: number, spinVA: number, dir: number, steps: number): number {
  let v = spinV * dir;
  let angle = 0;
  for (let i = 0; i < steps; i++) {
    if (v > 1 || v < -1) {
      v = Math.trunc(v * spinVA);
      angle += v;
    }
  }
  return angle;
}
